import produce from "immer";
import {
  ComponentType,
  DefaultComponentProperty,
} from "common/components/types";
import DesignComponent from "./design";
import DragLayerComponent from "./drag";

const Switch: ComponentType = {
  DragLayerComponent: DragLayerComponent,
  DesignComponent: DesignComponent,
  property: produce(DefaultComponentProperty, (draft) => {
    draft.name = "MSG_CREATOR_COMPONENT_NAME_SWITCH";
    draft.defaultName = "MSG_CREATOR_COMPONENT_NAME_SWITCH";
    draft.value = true;

    const initialWidth = 50;
    const initialHeight = 30;

    draft.style.defaultLayout.width = initialWidth;
    draft.style.defaultLayout.height = initialHeight;
    draft.style.defaultView.backgroundColor = "#94C4F7";
    draft.style.defaultView.borderWidth = 4;
    draft.style.defaultView.borderColor = "#4C9DF1";
    draft.style.defaultView.borderRadius = 100;

    draft.style.layout.width = initialWidth;
    draft.style.layout.height = initialHeight;
    draft.style.view.backgroundColor = "#94C4F7";
    draft.style.view.borderWidth = 4;
    draft.style.view.borderColor = "#4C9DF1";
    draft.style.view.borderRadius = 100;

    draft.events = ["switch_value_change_event"];
  }),
};

export default Switch;
